<script setup>
import dayjs from 'dayjs'

import { textColor } from '@/lib/utils'

import ChipTemplate from '@/components/shared/ChipTemplate.vue'

const props = defineProps({
  conditions: {
    type: Array,
    required: true,
  },
  conditionColors: {
    type: Object,
    required: true,
  },
  editMode: {
    type: Boolean,
    required: false,
    default: false,
  },
  highlightedId: {
    type: Number,
    required: false,
    default: null,
  },
})

const emit = defineEmits(['delete'])

</script>
<template>
  <q-timeline layout="dense">
    <q-timeline-entry
      v-for="condition in props.conditions"
      :key="condition.id"
      :subtitle="`${condition.createdByName} - ${dayjs(condition.createdAt).format('L')}`"
      :avatar="condition.createdByAvatarUrl"
      :color="conditionColors[condition.condition]"
      :class="{ 'row-highlight': condition.id === props.highlightedId, 'condition-entry--deletable': props.editMode && condition.isDeletable }"
    >
      <template #subtitle>
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <div style="opacity: .6;">
            {{ condition.createdByName }} - {{ dayjs(condition.createdAt).format('L') }}
          </div>
          <chip-template
            :values="[{
              label: condition.conditionLabel,
              color: conditionColors[condition.condition],
              textColor: textColor(conditionColors[condition.condition]),
              size: 'sm',
            }]"
          />
        </div>
      </template>
      <div class="text-caption">
        {{ condition.comment }}
      </div>
      <q-btn
        v-if="props.editMode && condition.isDeletable"
        class="condition-delete-btn"
        style="padding: 0;"
        size="md"
        flat
        rounded
        color="negative"
        icon="mdi-minus-circle-outline"
        @click="emit('delete', condition)"
      />
    </q-timeline-entry>
  </q-timeline>
</template>

<style scoped>
::v-deep(.q-timeline__subtitle) {
  opacity: 1 !important;
}
.condition-entry--deletable {
  padding-right: 3rem;
}
/* Centered on the content, excluding the 1.5rem bottom padding of .q-timeline__content */
.condition-delete-btn {
  position: absolute;
  right: -.5rem;
  top: calc(50% - .75rem);
  transform: translateY(-50%);
}
</style>
